// extracted by mini-css-extract-plugin
export var skipToMainContentLink = "J5ft5";